<template>
    <div class="px-3 py-2 text-muted shadow-sm border-bottom" style="background-color: white;">
        <div class="header-container">
            <!-- Logo Section -->
            <div class="d-flex align-items-center me-3">
                <RouterLink :to="'/'" class="text-decoration-none">
                    <div class="text-center py-3">
                        <img src="../../../dist/assets/GITSlogo.png" class="img-fluid" style="max-height: 75px;" />
                    </div>
                </RouterLink>
            </div>

            <!-- Header Buttons Section -->
            <div class="header-buttons">
                <!-- Language Switcher -->
                <div class="language-switcher me-2">
                    <button class="lang-btn" :class="{ active: $GetLocalization() === 'en' }"
                        @click="$SetLocalization('en')">{{ $Translate('english') }}</button>
                    <button class="lang-btn" :class="{ active: $GetLocalization() === 'ar' }"
                        @click="$SetLocalization('ar')">{{ $Translate('arabic') }}</button>
                </div>

                <!-- Jobs Button -->
                <RouterLink :to="'/Jobs'" v-if="this.$route.name === 'Applicant Profile Page'">
                    <button class="btn jobsBtn me-2">{{ $Translate('jobs') }}</button>
                </RouterLink>

                <!-- Applicant Profile Button -->
                <RouterLink :to="'/ApplicantProfile'" v-if="this.$route.name !== 'Applicant Profile Page' && isLoggedIn">
                    <button class="btn jobsBtn me-2">{{ $Translate('profile') }}</button>
                </RouterLink>

                <!-- Login Button -->
                <RouterLink v-if="!isLoggedIn" :to="'/Login'">
                    <button class="btn loginBtn">{{ $Translate('login') }}</button>
                </RouterLink>

                <!-- Logout Button -->
                <RouterLink v-if="isLoggedIn" :to="'/Login'" @click="logout()">
                    <button class="btn logoutBtn">{{ $Translate('logout') }}</button>
                </RouterLink>

            </div>
        </div>
    </div>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
    name: 'NavBar',
    data() {
        return {
            isLoggedIn: false,
        };
    },
    methods: {
        logout() {
            RemoveToken();
            RemoveApplicantId();
        }
    },
    mounted() {
        if (GetToken()) {
            this.isLoggedIn = true;
        }
    }
};
</script>

<style scoped>
/* Styles for Header Container */
.header-container {
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10%;
}

/* Button Section */
.header-buttons {
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
}

.btn {
    font-size: 16px;
    font-weight: bold;
    padding: 12px 30px;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    position: relative;
}

.jobsBtn {
    background-color: #FC7F3F;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}


.loginBtn {
    background-color: #00013A;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.logoutBtn {
    background-color: #C94C4C;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.logoutBtn:hover {
    background-color: #D7263D;
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.jobsBtn:hover {
    background-color: #e66e32;
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.loginBtn:hover {
    background-color: #000049;
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
    .header-container {
        padding: 0 5%;
    }

    .header-buttons {
        justify-content: center;
        margin-top: 10px;
    }

    .jobsBtn,
    .loginBtn {
        width: 100%;
        padding: 15px 0;
        margin-bottom: 10px;
    }
}

.language-switcher {
    display: flex;
    gap: 6px;
    background: #f0f0f0;
    padding: 4px;
    border-radius: 30px;
    align-items: center;
}

.lang-btn {
    background: transparent;
    border: none;
    padding: 6px 14px;
    font-size: 14px;
    font-weight: 600;
    color: #555;
    border-radius: 20px;
    transition: background-color 0.2s, color 0.2s;
    cursor: pointer;
}

.lang-btn.active {
    background-color: #00013A;
    color: white;
    pointer-events: none;
}

.lang-btn:hover {
    background-color: #FFD1A4;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

</style>